import { render, staticRenderFns } from "./plan-banner.vue?vue&type=template&id=477f7217&scoped=true&"
import script from "./plan-banner.vue?vue&type=script&lang=js&"
export * from "./plan-banner.vue?vue&type=script&lang=js&"
import style0 from "./plan-banner.vue?vue&type=style&index=0&id=477f7217&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477f7217",
  null
  
)

export default component.exports